import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Megaphone, X } from "lucide-react";
import { useApp } from "../store";

export const AnnouncementBar = () => {
  const { c } = useApp();
  const text = (c("announcement_text") || "").trim();
  const [dismissed, setDismissed] = useState(() => {
    return !!text && sessionStorage.getItem("pgp_announce_dismissed") === text;
  });
  const visible = !!text && !dismissed;

  useEffect(() => {
    document.documentElement.style.setProperty("--announce-h", visible ? "40px" : "0px");
    return () => document.documentElement.style.setProperty("--announce-h", "0px");
  }, [visible]);

  const close = () => {
    sessionStorage.setItem("pgp_announce_dismissed", text);
    setDismissed(true);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: -40 }}
          animate={{ y: 0 }}
          exit={{ y: -40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="announcement-bar"
          className="fixed top-0 inset-x-0 z-[70] h-10 bg-[#12254D] border-b border-[var(--accent-soft)]/10 flex items-center justify-center gap-3 px-10"
        >
          <Megaphone size={13} className="text-[var(--accent-soft)] shrink-0" />
          <p data-testid="announcement-text" className="font-mono2 text-[11px] sm:text-xs uppercase tracking-[0.18em] text-white/80 truncate">
            {text}
          </p>
          <button
            data-testid="announcement-close-button"
            onClick={close}
            aria-label="Fermer"
            className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-[var(--accent-soft)] transition-colors duration-300"
          >
            <X size={15} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
